import React from 'react';
import { Box, Typography } from '@mui/material';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import WidgetCard from './WidgetCard';
import { useWidgetData } from './useWidgetData';

interface ReceivingItem {
  status: number;
  statusName: string;
  count: number;
  /** Сколько дней самый старый документ без движения */
  maxIdleDays: number;
}

interface ReceivingResponse {
  items: ReceivingItem[];
}

const ACCENT = '#0891b2';

/** Подсказка, что нужно сделать, по статусу документа */
const HINTS: Record<number, string> = {
  6: 'К приёмке',
  12: 'Сканирование коробов',
  13: 'Подтвердить отправку',
  15: 'Ожидают подтверждения'
};

/** Виджет «Ожидают действия»: счётчики документов по статусам, требующим действия. Право: home.documents.receiving.view */
const ReceivingDocumentsWidget: React.FC = () => {
  const { data, loading, error, reload } = useWidgetData<ReceivingResponse>('/api/v2/home/documents/receiving');
  const items = data?.items || [];

  return (
    <WidgetCard
      title="Ожидают действия"
      icon={<PendingActionsOutlinedIcon />}
      accent={ACCENT}
      loading={loading}
      error={error}
      onRefresh={reload}
      scroll={false}
    >
      {items.map((it, i) => {
        const stale = it.count > 0 && it.maxIdleDays >= 4;
        return (
          <Box key={it.status} sx={{ px: 2, py: 0.9, display: 'flex', alignItems: 'center', gap: 1.5, borderTop: i ? '1px solid #f1f5f9' : 'none' }}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontSize: 13, color: '#0f172a' }} noWrap>{HINTS[it.status] || it.statusName}</Typography>
              {it.count > 0 && (
                <Typography sx={{ fontSize: 11.5, color: stale ? '#c2410c' : '#94a3b8' }} noWrap>
                  самый старый без движения {it.maxIdleDays} дн.
                </Typography>
              )}
            </Box>
            <Typography sx={{ fontSize: 18, fontWeight: 700, color: it.count ? ACCENT : '#cbd5e1' }}>{it.count}</Typography>
          </Box>
        );
      })}
    </WidgetCard>
  );
};

export default ReceivingDocumentsWidget;
